module.exports = __webpack_public_path__ + "static/media/fe.dbb8096d.svg";